// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("../../reason/common/Env.bs.js");
let React = require("react");
let Loader = require("../common/Components/Loader.bs.js");
let Sentry = require("../../reason/Sentry.bs.js");
let MapPolygon = require("../common/MapPolygon.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let GoogleMaps = require("@deck.gl/google-maps");
let ReactErrorBoundary = require("react-error-boundary");
let ReactGoogleMaps = require("@vis.gl/react-google-maps");
let NotificationSettingsAreaMapQuery_graphql = require("../../__generated__/NotificationSettingsAreaMapQuery_graphql.bs.js");

let convertVariables = NotificationSettingsAreaMapQuery_graphql.Internal.convertVariables;

let convertResponse = NotificationSettingsAreaMapQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationSettingsAreaMapQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, NotificationSettingsAreaMapQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, NotificationSettingsAreaMapQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(NotificationSettingsAreaMapQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(NotificationSettingsAreaMapQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(NotificationSettingsAreaMapQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(NotificationSettingsAreaMapQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function NotificationSettingsAreaMap$Overlay(props) {
  let polygons = props.polygons;
  let map = ReactGoogleMaps.useMap();
  let layer = React.useMemo(() => MapPolygon.makeLayer("notification-settings-area-geometries", polygons, [
    40,
    97,
    141,
    36
  ], [
    40,
    97,
    141,
    190
  ], 2), [polygons]);
  React.useEffect(() => {
    if (map === null) {
      return;
    }
    let overlay = new GoogleMaps.GoogleMapsOverlay({
      interleaved: false,
      layers: [layer]
    });
    overlay.setMap(map);
    return () => {
      overlay.setMap(null);
      overlay.finalize();
    };
  }, [
    map,
    layer
  ]);
  return null;
}

let Overlay = {
  make: NotificationSettingsAreaMap$Overlay
};

function NotificationSettingsAreaMap$Content(props) {
  let data = use({
    areaIds: props.areaIds
  }, "store-or-network", undefined, undefined);
  let polygons = React.useMemo(() => Stdlib_Array.keepSome(data.areasV5).flatMap(area => {
    let polygon = area.geometry.byType;
    switch (polygon.__typename) {
      case "MapMultiPolygon" :
        return polygon.polygons.map(polygon => MapPolygon.make(polygon.exteriorRing.coordinates.map(coordinate => ({
          lat: coordinate.lat,
          lng: coordinate.lon
        })), polygon.interiorRings.map(ring => ring.coordinates.map(coordinate => ({
          lat: coordinate.lat,
          lng: coordinate.lon
        })))));
      case "MapPolygon" :
        return [MapPolygon.make(polygon.exteriorRing.coordinates.map(coordinate => ({
            lat: coordinate.lat,
            lng: coordinate.lon
          })), polygon.interiorRings.map(ring => ring.coordinates.map(coordinate => ({
            lat: coordinate.lat,
            lng: coordinate.lon
          }))))];
      case "__unselected" :
        return [];
    }
  }), [data.areasV5]);
  let bounds = MapPolygon.bounds(polygons);
  if (bounds !== undefined) {
    return JsxRuntime.jsxs(ReactGoogleMaps.APIProvider, {
      children: [
        JsxRuntime.jsx(ReactGoogleMaps.Map, {
          className: "h-full w-full",
          defaultBounds: bounds,
          gestureHandling: "cooperative",
          clickableIcons: false,
          zoomControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          scaleControl: true
        }),
        JsxRuntime.jsx(NotificationSettingsAreaMap$Overlay, {
          polygons: polygons
        })
      ],
      apiKey: Stdlib_Option.getOrThrow(Env.google_key, "A Google Maps API key is required for the notification settings area map")
    });
  } else {
    return null;
  }
}

let Content = {
  make: NotificationSettingsAreaMap$Content
};

function NotificationSettingsAreaMap(props) {
  let areaIds = props.areaIds;
  return JsxRuntime.jsx("section", {
    children: areaIds.length !== 0 ? JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
        FallbackComponent: param => JsxRuntime.jsx("div", {
          children: "The area map could not be loaded. You can still edit and save your areas.",
          className: "flex h-full items-center justify-center p-6 text-center text-sm text-gray-600"
        }),
        children: JsxRuntime.jsx(React.Suspense, {
          children: JsxRuntime.jsx(NotificationSettingsAreaMap$Content, {
            areaIds: areaIds
          }),
          fallback: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Loader.make, {}),
            className: "flex h-full items-center justify-center"
          })
        }),
        onError: error => Sentry.captureException(error, "NotificationSettingsAreaMap.res", undefined, undefined, undefined)
      }, areaIds.join(",")) : JsxRuntime.jsx("div", {
        children: "Select at least one area to see its map coverage.",
        className: "flex h-full items-center justify-center p-6 text-center text-sm text-gray-600"
      }),
    className: "h-72 overflow-hidden rounded border border-gray-200 bg-gray-100 lg:h-96"
  });
}

let make = NotificationSettingsAreaMap;

exports.Query = Query;
exports.Overlay = Overlay;
exports.Content = Content;
exports.make = make;
/* use Not a pure module */
